import React, { useReducer, useEffect } from 'react';

import BigNumbers from './BigNumbers';
import Filters from './Filters';
import IncidentCard from './IncidentCard';
import reducer from './reducer';
import { getMarkup } from './util';

import './App.css';


function App() {
  const [state, dispatch] = useReducer(reducer, {
    shootingsById: {},
    shootingIds: [],
    filteredShootingIds: [],
    copy: [],
    filterOptions: {},
  });

  useEffect(() => {
    // Fetch the data.
    fetch(`${process.env.PUBLIC_URL}/data.json`)
      .then(response => response.json())
      .then(data => dispatch({ type: 'setdata', data }));
  }, []);

  if (state.shootingIds.length === 0 || !state.filterOptions) {
    return null;
  }

  const incidentCards = state.filteredShootingIds.map(id => (
    <IncidentCard key={id} shooting={state.shootingsById[id]} />
  ));

  /* eslint-disable react/no-danger */
  return (
    <article className="story App" itemScope itemType="http://schema.org/Article">
      <div className="container">
        <div className="column column-wide">
          <header className="section section-contentHeader">
            <div className="section_header">
              <h1 className="hdg hdg-1 hdg-serif hdg-light hdg-center">{state.copy.hed}</h1>
            </div>
          </header>
        </div>
        <div className="column column-standard">
          <div className="section">
            <div className="story_dek story_dek-small Intro" dangerouslySetInnerHTML={getMarkup(state.copy.intro)} />
            <p className="story_byline">
              {state.copy.dateline}
              &nbsp;|&nbsp;
              <span>by&nbsp;</span>
              {state.copy.byline}
            </p>
          </div>
        </div>
      </div>

      <div className="container">
        <div className="column column-narrow">
          <div className="story_body" itemProp="articleBody">
            <BigNumbers numbers={state.copy.big_numbers} />

            <Filters
              options={state.filterOptions}
              defaultFilters={{ }}
              onChangeFilters={(filters, filterClicked) => dispatch({ type: 'updatefilters', filters, filterClicked })}
            />

            <div>
              {incidentCards}
            </div>
          </div>
        </div>
      </div>
    </article>
  );
  /* eslint-enable react/no-danger */
}

export default App;
